import Vue from 'vue'
import Account from '@/api/account'
import { sleep, range } from '@/utils/helpers'
import { hasCordova } from '@/cordova'

export default Vue.extend({
  computed: {
    /**
     * ブラウザを開くときに付与するクエリ
     */
    $_appBrowserQuery(): string {
      const app = this.$route.query.app || hasCordova ? '1' : '0'
      const token = this.$route.query.token || this.$store.getters['Auth/token']
      return `?app=${app}&token=${token}`
    }
  },
  methods: {
    $_range: range,

    /**
     * 最終アクション時間の更新
     */
    $_updateActionTime() {
      try {
        Account.updateActionTime()
      } catch (e) {
        console.error(e)
      }
    },

    /**
     * Store state の reset
     */
    $_resetStoreState(exclusion?: RegExp) {
      // entries として取得したデータを残している vuex はここで毎回リセット
      const resetStateMutations = Object.keys(this.$store['_mutations'])
      for (const mutation of resetStateMutations) {
        if (!mutation.match(/resetState/)) {
          continue
        }
        const moduleName = mutation.split('/')[0]
        if (exclusion && exclusion.test(moduleName)) {
          continue
        }
        this.$store.commit(mutation)
      }
    },

    /**
     * $root.$el のスクロール値を取得
     */
    $_getRootScroll() {
      const el = this.$root.$el
      let scrollState = null
      if (el) {
        const rect = el.getBoundingClientRect()
        let top = -rect.top
        let height = window.innerHeight
        if (top < 0) {
          height += top
          top = 0
        }
        if (rect.height && top + height > rect.height) {
          height = rect.height - top
        }
        scrollState = {
          top,
          bottom: top + height
        }
      }
      return scrollState
    },

    /**
     * $root.$el の scroll.top
     */
    $_getRootScrollTop(): number {
      const scroll = this.$_getRootScroll()
      return scroll ? ~~scroll.top : 0
    },

    /**
     * iOS で textarea にキーボードが重なって隠れる対策
     */
    async $_visibleTextarea(selector: string, delay: number = 500) {
      if (!this.$_platformIsIOS) return
      let elm = document.querySelector(selector)
      if (!elm) return
      await sleep(delay)
      elm.scrollIntoView()
      elm = null
    },

    /**
     * ページ遷移. URL によってページ内か外部かを切り替える
     */
    async $_jump(url: string) {
      if (url.indexOf('https://') === 0) {
        if (this.$_hasCordova) {
          await this.$_clearCache()
        }
        this.$_open(url + this.$_appBrowserQuery)
      } else {
        this.$router.push(url)
      }
    }
  }
})
